<template>
    <div class="content">
        <div v-show='showWechat'>
			<div class="wechat">
				<p class="red"><strong>请点击右上角 [ ··· ] </strong></p>
				<p>选择 <strong class="red">在浏览器打开</strong></p>
				<p>否则可能会无法打开下载链接</p>
			</div>
		</div>
        <a-tabs v-model:activeKey="activeKey" centered>
            <a-tab-pane key="1" tab="精读圣经">
                <BibleView />
            </a-tab-pane>
            <a-tab-pane key="2" tab="诗歌本" force-render>
                <div class="tab-pane fade" id="tab2">
                    <HymnView />                  
                </div>
            </a-tab-pane>
        </a-tabs>
        <footer class="footer">
            <a class="footer-text" :href="'mailto:' + email">                
                联系我们 <span class="footer-icon">✉</span> {{ email }}
            </a>
        </footer>
    </div>
</template>

<script>
import { ref } from 'vue';
import BibleView from './BibleView.vue'
import HymnView from './HymnView.vue'
export default {
    name: 'HomeView',
    props: {

    },
    data() {
        return {
            showWechat: false,
            activeKey: ref('1'),
            email: 'znapps@outlook.com', 
        };
    },
    computed: {

    },
    setup() {
        
    },
    created() {
        if (this.global.is_weixin()) {
            this.showWechat = true
        }
        if (this.$route.query.app == 'hymn') {
            this.activeKey = ref('2')
        }
    },
    mounted() {

    },
    watch: {

    },
    methods: {
        openHref (category, url) {
            window.location.href = url
            this.$gtag.event('button', { 'event_category': category, 'event_label': url })
            this.$ba.trackEvent(category, 'button', url, '')
        },
        copyEmail() {
            const input = document.createElement('input')
            input.value = this.email
            document.body.appendChild(input)
            input.select()
            input.setSelectionRange(0, 9999)

            try {
                document.execCommand('copy')
                this.copyText = '已复制'
                this.showToast = true
                setTimeout(() => {
                    this.showToast = false
                    this.copyText = '点击复制'
                }, 2000)
            } catch (err) {
                this.copyText = '出现异常，请手动复制。'
            }
            document.body.removeChild(input)
        },
    },
    components: {
        BibleView,
        HymnView
    },
};
</script>

<style scoped>

.content {
    display:inline-block;
    text-align: left;
    max-width: 800px;
}
.wechat {
    position:relative;
    padding-top:20px;
    padding-bottom: 10px;
    color: black;
    background-color: #ebe7e7;
    font-size: 22px;
    text-align: center;
}
.red {
    color: red;
}
.description {
    color: gray;
    padding: 10px;
    -webkit-overflow-scrolling:touch;
    background-color:#efeff4;
}
.info {
    color: gray;
}
.os {
    padding: 10px;
}
p {
    margin: 0px;
}
a-divider {
    height: 1px;
}
.divider {
    width: 100%;
    height: 1px;
    position: relative;
    background-color: #eeeeee;
}
.footer {
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
    display: flex;
    justify-content: center;
    padding: 14px 20px;
    background: rgba(255, 255, 255, 0.92);
    backdrop-filter: blur(10px);
    border-top: 1px solid rgba(0, 0, 0, 0.06);
    z-index: 100;
}

.footer-text {
    display: inline-flex;
    align-items: center;
    gap: 6px;
    font-size: 14px;
    color: #555;
    text-decoration: none;
    cursor: pointer;
    transition: color 0.2s;
}

.footer-text:active {
    color: #1890ff;
}

.footer-icon {
    font-size: 13px;
    opacity: 0.5;
}

@media (max-width: 768px) {
    .footer {
        padding: 12px 16px;
    }
    .footer-text {
        font-size: 13px;
    }
}
</style>
